import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateGroupAttribute } from "../../../../../actions/product";

const UpdateAttributeGroups = ({ SelectItem, setEdit }) => {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({
    name: SelectItem?.name ?? "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setloading(true);
      const res = await dispatch(
        updateGroupAttribute({ ...formData, sortOrder: 1 }, SelectItem._id)
      );
      if (res) {
        setloading(false);
        setEdit({
          open: false,
          edit: "",
          title: "",
        });
      }
    } catch (error) {
      setloading(true);
    }
  };
  return (
    <div>
      <div className="px-4 ">
        <form onSubmit={handleSubmit}>
          <div className=" mt-3">
            <input
              type="text"
              className="add-button mt-3"
              required
              placeholder="Name"
              name="name"
              autoComplete="off"
              value={formData.name}
              onChange={(e) =>
                setformData({ ...formData, [e.target.name]: e.target.value })
              }
            />

            <div className=" mt-3 ">
              <button type="submit" className="update-Order-button">
                {loading ? "Loading..." : "Update"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateAttributeGroups;
